// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  orgId: 'admin',
  appBaseUrl: 'https://mif-subscription-admin.dev.storyshaper.io/',
  authServerUrl: 'https://hub-staging.storyshaper.io/green/',
  parrotApiBaseUrl: 'https://hub-staging.storyshaper.io/parrot_subscription', // if run using 'start dotnet watch run'
  apiBaseUrl: 'https://hub-staging.storyshaper.io/mif_subscription',
  clientSecret: '',
  clientId: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
